<template>
  <div class="login-wrapper">

    <div class="login">

      <img src="/static/img/suez-white.png" class="logo"/>

      <h2>Mot de passe oublié</h2>

      <!-- login form -->
      <form class="ui form loginForm" v-on:submit.prevent="submit">

        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-lock"></i></span>
          <input class="form-control" name="username" placeholder="Nouveau mot de passe" type="password" v-model="newPassword">
        </div>

        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-lock"></i></span>
          <input class="form-control" name="password" placeholder="Confirmez le mot de passe" type="password" v-model="confirmNewPassword">
        </div>

        <message
          :obj=resetPassword.message
          hide-mutation-type="CLEAR_RESET_PASSWORD_MESSAGE">
        </message>

        <button type="submit" v-bind:class="'btn btn-primary btn-lg'">Valider
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Message from './shared/Message'

export default {
  computed: {
    ...mapState([
      'resetPassword',
    ]),
  },
  data () {
    return {
      newPassword: '',
      confirmNewPassword: ''
    }
  },
  methods: {
    submit () {
      console.log("reset it => " , this.$route.params.adminId)
      this.$store.dispatch('resetPassword', {
        password: this.newPassword,
        confirmPassword: this.confirmNewPassword,
        adminId: this.$route.params.adminId
      })
    }
  },
  components: {
    Message,
  },
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// ResetPassword.vue?7cf29f26